<script setup lang="ts">
import { PhxsgLoaderProps, PhxsgLoader as PhxsgCoreLoader } from '@sg-core/src/View/Components/Atoms/Loader';

defineProps<PhxsgLoaderProps>();
</script>

<template>
  <PhxsgCoreLoader v-bind="$props" type="circle" />
</template>

<style src="./loader.css" />
